import React from "react";
import './Role.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint , faEye, faLightbulb, faBullseye } from '@fortawesome/free-solid-svg-icons';
export default function Role(){

    return(
        <div className="container mr-t80">
           
            <div className="row">
                <div className="col-md-3">
                   <div className="innerAbout">
                   <h5 className="text-center">Bring Your Vision to Life
                   </h5>
              <div className="text-center">
              <div className="iconBg-1">
                <FontAwesomeIcon
                icon={faEye}
                className="icon"
            />
                  </div>
              </div>
                  <p className="text-justify">Experience and personalise in a welcoming setting, ensuring your designs are crafted to perfection with premium materials and advanced techniques.</p>
                   </div>
                </div>
                <div className="col-md-3">
              <div className="innerAbout1">
              <h5 className="text-center">Customized Printing Solutions</h5>
                 <div className="text-center">
                 <div className="iconBg-2">
                  <FontAwesomeIcon
                icon={faPrint}
                className="icon"
            />
                  </div>
                 </div>
                  <p className="text-justify">Work directly with our specialists to create vibrant marketing materials, business cards, or packaging that aligns with your brand’s identity.</p>
                </div>
              </div>
                <div className="col-md-3">
               <div className="innerAbout">
               <h5 className="text-center">Precision and Creativity</h5>
              <div className="text-center">
              <div className="iconBg-3 ">
                <FontAwesomeIcon
                icon={faLightbulb}
                className="icon"
            />
                  </div>
              </div>
                  <p className="text-justify">Collaborate with us for tailored printing services that combine innovative designs, quality craftsmanship, and eco-friendly practices and efficient service.</p>
               </div>
          


                </div>
                <div className="col-md-3">
                <div className="innerAbout1">
                <h5 className="text-center">Elevate Your Brand</h5>  
              <div className="text-center">
              <div className="iconBg-4">
                <FontAwesomeIcon
                icon={faBullseye}
                className="icon"
            />
                  </div>
              </div>
                  <p className="text-justify">Transform your ideas into impactful prints that leave a lasting impression with our printing services and ideas the state-of-the-art printing solutions with advancement.</p>
                </div>
                </div>
            </div>
        </div>
    )
}